/*
 * TunePad
 *
 * Michael S. Horn
 * Northwestern University
 * michael-horn@northwestern.edu
 *
 * This project was funded by the National Science Foundation (grant DRL-1612619).
 * Any opinions, findings and conclusions or recommendations expressed in this
 * material are those of the author(s) and do not necessarily reflect the views
 * of the National Science Foundation (NSF).
 */
import iconAutocompile from './icon-autocompile.svg';
import iconCheck from './icon-check.svg';
import iconCopy from './icon-copy.svg';
import iconCrossCircle from './icon-cross-circle.svg'
import iconDownload from './icon-download.svg';
import iconError from './icon-error.svg';
import iconFile from './icon-file.svg';
import iconFileCSV from './icon-file-csv.svg';
import iconFileJSON from './icon-file-json.svg';
import iconFileText from './icon-file-text.svg';
import iconGear from './icon-gear.svg';
import iconHistory from './icon-history.svg';
import iconInsert from './icon-insert.svg';
import iconLibrary from './icon-library.svg';
import iconLock from './icon-lock.svg';
import iconMidiRoll from './icon-midiroll.svg'
import iconMinus from './icon-minus.svg';
import iconMusic from './icon-music.svg';
import iconPaintbrush from './icon-paintbrush.svg';
import iconPause from './icon-pause.svg';
import iconPiano from './icon-piano.svg';
import iconPlay from './icon-play.svg';
import iconPlus from './icon-plus.svg';
import iconProfile from './icon-profile.svg';
import iconQRCode from './icon-qrcode.svg';
import iconQuestionCircle from './icon-question-circle.svg';
import iconRecompile from './icon-recompile.svg';
import iconShare from './icon-share.svg';
import iconSpinner from './icon-spinner.svg';
import iconStop from './icon-stop.svg';
import iconTrash from './icon-trash.svg';
import logoTunePad from './logo-tunepad.svg';
import logoTunePadCircle from './logo-tunepad-circle.svg';
import iconWaveform from './icon-waveform.svg';

/**
 * ```html
 * <tunepad-icon icon="trash"></tunepad-icon>
 * ```
 * ### Available Icons
 * * autocompile
 * * canvas
 * * checkmark
 * * copy
 * * cross-circle
 * * download
 * * error
 * * file
 * * file-csv
 * * file-json
 * * file-text
 * * gear
 * * insert
 * * history
 * * library
 * * lock
 * * midi
 * * midiroll
 * * minus
 * * music
 * * paintbrush
 * * pause
 * * piano
 * * play
 * * plus
 * * profile
 * * qrcode
 * * question-circle
 * * recompile
 * * score
 * * share
 * * spinner
 * * stop
 * * trash
 * * waveform
 * * logo-tunepad
 * * logo-tunepad-circle
 */

export class TunePadIcon extends HTMLElement {

    static observedAttributes = [ "icon" ];
    static readonly ELEMENT = "tunepad-icon";

    private div : HTMLDivElement;


    constructor() {
        super();
        this.div = document.createElement('div');
        this.div.classList.add('icon');
    }

    connectedCallback() {
        this.append(this.div);
    }
    disconnectedCallback() { }

    attributeChangedCallback(name : string, oldValue : string, newValue : string) {
        if (name === 'icon' && newValue != oldValue) {
            switch (newValue) {
                case 'autocompile': this.div.innerHTML = iconAutocompile; break;
                case 'canvas': this.div.innerHTML = iconPaintbrush; break;
                case 'checkmark': this.div.innerHTML = iconCheck; break;
                case 'copy': this.div.innerHTML = iconCopy; break;
                case 'cross-circle': this.div.innerHTML = iconCrossCircle; break;
                case 'download': this.div.innerHTML = iconDownload; break;
                case 'error': this.div.innerHTML = iconError; break;
                case 'file': this.div.innerHTML = iconFile; break;
                case 'file-csv': this.div.innerHTML = iconFileCSV; break;
                case 'file-json': this.div.innerHTML = iconFileJSON; break;
                case 'file-text': this.div.innerHTML = iconFileText; break;
                case 'gear': this.div.innerHTML = iconGear; break;
                case 'history': this.div.innerHTML = iconHistory; break;
                case 'insert': this.div.innerHTML = iconInsert; break;
                case 'library': this.div.innerHTML = iconLibrary; break;
                case 'lock': this.div.innerHTML = iconLock; break;
                case 'midi': this.div.innerHTML = iconMidiRoll; break;
                case 'midiroll': this.div.innerHTML = iconMidiRoll; break;
                case 'minus': this.div.innerHTML = iconMinus; break;
                case 'music': this.div.innerHTML = iconMusic; break;
                case 'paintbrush': this.div.innerHTML = iconPaintbrush; break;
                case 'pause' : this.div.innerHTML = iconPause; break;
                case 'piano' : this.div.innerHTML = iconPiano; break;
                case 'play': this.div.innerHTML = iconPlay; break;
                case 'plus': this.div.innerHTML = iconPlus; break;
                case 'profile': this.div.innerHTML = iconProfile; break;
                case 'qrcode': this.div.innerHTML = iconQRCode; break;
                case 'question-circle': this.div.innerHTML = iconQuestionCircle; break;
                case 'recompile': this.div.innerHTML = iconRecompile; break;
                case 'score': this.div.innerHTML = iconMusic; break;
                case 'share': this.div.innerHTML = iconShare; break;
                case 'spinner': this.div.innerHTML = iconSpinner; break;
                case 'stop': this.div.innerHTML = iconStop; break;
                case 'trash': this.div.innerHTML = iconTrash; break;
                case 'waveform': this.div.innerHTML = iconWaveform; break;
                case 'logo-tunepad': this.div.innerHTML = logoTunePad; break;
                case 'logo-tunepad-circle': this.div.innerHTML = logoTunePadCircle; break;
                default: this.div.innerHTML = '';
            }
            const svg = this.div.querySelector('svg');
            if (svg) svg.style.width = '100%';
        }
    }
}
